<script lang="ts">
    import List from './List.svelte';
    import WordCard from './WordCard.svelte';
    import type {WordIdToSentences} from '$lib/data/wordIdToSentences';
    import type {UserWordsMapStore} from '$lib/classes/stores/get-user-words-map';
    import type {DisplayWords} from '$lib/stores/displayWords';
    import type {FilterSettings} from '$lib/stores/filterSettings';
    import type {LoggedIn} from '$lib/classes/stores/logged-in';
    import type {CurrentWord} from '$lib/stores/currentWord';
    import {type Device, DeviceType} from '$lib/stores/ui/device';

    export let wordIdToSentences: WordIdToSentences
    export let userWordsMap: UserWordsMapStore
    export let currentWord: CurrentWord
    export let displayWords: DisplayWords
    export let filterSettings: FilterSettings
    export let loggedIn: LoggedIn
    export let device: Device
</script>

<div id="list-and-card">

    <div id="list">
        <List
                wordIdToSentences={wordIdToSentences}
                userWordsMap={userWordsMap}
                currentWord={currentWord}
                displayWords={displayWords}
                filterSettings={filterSettings}
                loggedIn={loggedIn}
                device={device}
        />
    </div>

    <div id="card">
        {#if $currentWord && $device === DeviceType.Desktop}
            <WordCard
                    currentWord={currentWord}
                    wordIdToSentences={wordIdToSentences}
                    userWordsMap={userWordsMap}
                    filterSettings={filterSettings}
                    loggedIn={loggedIn}
                    device={device}
            />
        {/if}
    </div>

</div>


<style>
    #list-and-card {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        min-height: 0; /* needed so that virtual list doesn't affect height of this element */
        /*border: 1px solid magenta;*/
    }

    #list {
        position: relative;
        width: 45%;
        border-left: 2px solid var(--color-dark);
        border-right: 2px solid var(--color-dark);
        /*border: 1px solid orange;*/
    }

    #card {
        width: 55%;
        /*border: 1px solid darkolivegreen;*/
    }

    @media (max-width: 1000px) {

        #list-and-card {
            border: revert;
            /*border: 1px solid orangered;*/
        }

        #list {
            width: 100%;
            border: revert;
        }

        #card {
            display: none;
        }
    }

</style>